import React from 'react';
import { ShimmerBlock, DotBounceLoading } from 'mintel-react-ui';

import * as styles from './NavLoading.scss';

export const CenteredDotBounceLoading = (): JSX.Element => (
  <div className={styles.dotBounce} data-testid="dot-bounce-loading">
    <DotBounceLoading />
  </div>
);

const NavLoading = ({
  children = undefined,
}: {
  children?: React.ReactNode;
}): JSX.Element => (
  <div data-testid="nav-loading">
    <div className={styles.header}>
      <div className={styles.logo} />
      <div className={styles.products}>
        <ShimmerBlock className={styles.productShimmer} />
        <ShimmerBlock className={styles.productShimmer} />
        <ShimmerBlock className={styles.productShimmer} />
        <ShimmerBlock className={styles.accountShimmer} />
      </div>
    </div>
    {children || <CenteredDotBounceLoading />}
  </div>
);

export default NavLoading;
